import { render, staticRenderFns } from "./ResourceCalendarHorizontalLT1.vue?vue&type=template&id=710f67a5&"
import script from "./ResourceCalendarHorizontalLT1.vue?vue&type=script&lang=js&"
export * from "./ResourceCalendarHorizontalLT1.vue?vue&type=script&lang=js&"
import style0 from "./ResourceCalendarHorizontalLT1.vue?vue&type=style&index=0&id=710f67a5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports